import { MemoryTab } from '@apps/web/components/memory/memory_tab';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@apps/web/components/ui/dialog';

export function CaregiverMemoryDialog({
    organizationId,
    caregiverId,
    onClose,
}: {
    readonly organizationId: string;
    readonly caregiverId: string | null;
    readonly onClose: () => void;
}) {
    return (
        <Dialog
            open={caregiverId !== null}
            onOpenChange={(open) => {
                if (!open) {
                    onClose();
                }
            }}
        >
            <DialogContent className="max-h-[85vh] overflow-hidden sm:max-w-3xl">
                <DialogHeader>
                    <DialogTitle>Caregiver memory</DialogTitle>
                </DialogHeader>
                <div className="min-h-0 overflow-y-auto">
                    <MemoryTab
                        organizationId={organizationId}
                        entityId={caregiverId}
                        entityType="caregiver"
                    />
                </div>
            </DialogContent>
        </Dialog>
    );
}
